(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-category-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-category-navigation')) {
    customElements.define('ds-category-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.ds-category-nav__track');
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        if (!this.track) return;
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.previous.hidden = max < 2 || position < 2;
          this.next.hidden = max < 2 || position >= max - 2;
        };
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const direction = button.dataset.direction === 'next' ? -1 : 1;
            this.track.scrollBy({left: direction * this.track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          }, options);
        });
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-compact-category-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-compact-category-navigation')) {
    customElements.define('ds-compact-category-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.ds-compact-category-nav__track');
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        if (!this.track) return;
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.previous.hidden = max < 2 || position < 2;
          this.next.hidden = max < 2 || position >= max - 2;
        };
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const direction = button.dataset.direction === 'next' ? -1 : 1;
            this.track.scrollBy({left: direction * this.track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          }, options);
        });
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-fornir-category-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-fornir-category-navigation')) {
    customElements.define('ds-fornir-category-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.ds-fornir-nav__track');
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        if (!this.track) return;
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.previous.hidden = max < 2 || position < 2;
          this.next.hidden = max < 2 || position >= max - 2;
        };
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const direction = button.dataset.direction === 'next' ? -1 : 1;
            this.track.scrollBy({left: direction * this.track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          }, options);
        });
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsv2-system"] && !Shopify.designMode) return;
  try {
    
function initDsv2System() {
  const root = document.querySelector('[data-dsv2-root]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const controller = new AbortController();
  // Use the samples app's own form targeting and Ajax lifecycle.
  // The app continues to own sample selection, limits, properties and cart writes.
  function targetSampleForm() {
    document.querySelectorAll('.js-product-samples').forEach((block) => {
      block.closest('form')?.classList.add('js-product-sample-form');
      if (!block.parentElement.querySelector('[data-dsv2-sample-status]')) {
        const status = document.createElement('p');
        status.className = 'dsv2-sample-status';
        status.dataset.dsv2SampleStatus = '';
        status.setAttribute('role', 'status');
        block.after(status);
      }
    });
  }
  targetSampleForm();
  window.ProductSample = Object.assign(window.ProductSample || {}, { type: 'ajax' });
  let sampleButton = null;
  let sampleTimer;
  const sampleStatus = () => document.querySelector('[data-dsv2-sample-status]');
  const unlockSample = () => {
    clearTimeout(sampleTimer);
    if (sampleButton) { sampleButton.disabled = false; sampleButton.removeAttribute('aria-busy'); }
    sampleButton = null;
  };
  document.body.addEventListener('beforeAddToSample.productSamples', (event) => {
    const host = event.detail?.button;
    const button = host?.matches?.('[product-samples-button]') ? host : host?.querySelector?.('[product-samples-button]');
    if (!button?.closest('.js-product-samples')) return;
    sampleButton = button;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (sampleStatus()) sampleStatus().textContent = 'מוסיף דוגמית לסל…';
    clearTimeout(sampleTimer);
    sampleTimer = setTimeout(() => {
      if (sampleStatus()) sampleStatus().textContent = 'ההוספה מתעכבת. בדקו את הסל לפני ניסיון נוסף.';
    }, 30000);
  }, { signal: controller.signal });
  document.body.addEventListener('addedToCart.productSamples', () => {
    if (!sampleButton) return;
    if (sampleStatus()) sampleStatus().textContent = 'הדוגמית נוספה לסל';
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    unlockSample();
  }, { signal: controller.signal });
  document.body.addEventListener('addToCartError.productSamples', () => {
    if (!sampleButton) return;
    if (sampleStatus()) sampleStatus().textContent = 'לא הצלחנו להוסיף את הדוגמית. בדקו את הודעת האפליקציה ונסו שוב.';
    unlockSample();
  }, { signal: controller.signal });
  document.body.addEventListener('afterAddToSample.productSamples', () => {
    if (sampleButton && sampleStatus()) sampleStatus().textContent = '';
    unlockSample();
  }, { signal: controller.signal });
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => visible.set(entry.target, entry.isIntersecting));
    document.documentElement.dataset.dsv2HideSticky = String(Array.from(visible.values()).some(Boolean));
  }, { threshold: 0.1 });
  const visible = new Map();
  function isolateDimensions() {
    document.querySelectorAll('.shopify-section--main-product h1.product-title, .dsv2-installation, .dsv2-related-grid h3, .dsv2-accessory-row__product, .dsv2-faq__answer, .dsv2-full-description').forEach((scope) => {
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        if (!walker.currentNode.parentElement.closest('bdi, script, style')) nodes.push(walker.currentNode);
      }
      nodes.forEach((node) => {
        const content = node.textContent;
        const matches = [...content.matchAll(/\d+(?:\.\d+)?\s*[×xX]\s*\d+(?:\.\d+)?/g)];
        if (!matches.length) return;
        const fragment = document.createDocumentFragment();
        let index = 0;
        matches.forEach((match) => {
          fragment.append(content.slice(index, match.index));
          const dimensions = document.createElement('bdi');
          dimensions.dir = 'ltr';
          dimensions.textContent = match[0];
          fragment.append(dimensions);
          index = match.index + match[0].length;
        });
        fragment.append(content.slice(index));
        node.replaceWith(fragment);
      });
    });
  }
  function observeButtons() {
    targetSampleForm();
    isolateDimensions();
    document.querySelectorAll('.shopify-section--main-product .product-info buy-buttons button[type="submit"], .js-product-samples [product-samples-button], [data-apply-quantity], .dsv2-accessory-form button[type="submit"], .dsv2-final-cta__button, .dsv2-answer-link').forEach((button) => {
      if (!visible.has(button)) { visible.set(button, false); observer.observe(button); }
    });
    for (const button of visible.keys()) if (!button.isConnected) { visible.delete(button); observer.unobserve(button); }
  }
  observeButtons();
  document.addEventListener('shopify:section:load', observeButtons, { signal: controller.signal });
  const rerender = new MutationObserver(observeButtons);
  const main = document.querySelector('.shopify-section--main-product');
  if (main) rerender.observe(main, { subtree: true, childList: true });
  document.addEventListener('variant:add', (event) => {
    const form = event.target.closest?.('.dsv2-accessory-form');
    if (!form) return;
    const status = form.querySelector('[data-dsv2-accessory-status]');
    if (status) status.textContent = 'המוצר נוסף לסל';
  }, { signal: controller.signal });
  document.addEventListener('cart:error', (event) => {
    const form = event.target.closest?.('.dsv2-accessory-form');
    if (!form) return;
    const status = form.querySelector('[data-dsv2-accessory-status]');
    if (status) status.textContent = event.detail?.error || 'לא הצלחנו להוסיף את המוצר. נסו שוב.';
  }, { signal: controller.signal });
  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target.contains(root)) return;
    unlockSample(); observer.disconnect(); rerender.disconnect(); controller.abort(); delete document.documentElement.dataset.dsv2HideSticky;
  }, { signal: controller.signal });
}
initDsv2System();
document.addEventListener('shopify:section:load', initDsv2System);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsv2-wall-calculator"] && !Shopify.designMode) return;
  try {
    
function initDsv2WallCalculators(scope = document) {
  scope.querySelectorAll('[data-dsv2-wall-calculator]').forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const lifecycle = new AbortController();
    const on = (node, type, fn, opts = {}) => node?.addEventListener(type, fn, { ...opts, signal: lifecycle.signal });
    const $ = (s) => root.querySelector(s);
    const form = $('[data-calculator-form]');
    const width = $('[data-wall-width]'), height = $('[data-wall-height]');
    const result = $('[data-calculator-result]'), error = $('[data-calculator-error]'), warning = $('[data-height-warning]');
    const apply = $('[data-apply-quantity]'), after = $('[data-after-apply]');
    const modal = $('[data-glue-modal]'), glueInput = $('[data-glue-input]'), glueButton = $('[data-add-glue]'), glueError = $('[data-glue-error]');
    const variants = JSON.parse($('[data-panel-variants]').textContent);
    const money = (cents) => new Intl.NumberFormat('he-IL', { style: 'currency', currency: root.dataset.currency || 'ILS', maximumFractionDigits: 2 }).format(cents / 100);
    const mainForm = () => document.querySelector('.shopify-section--main-product form[id^="product-form-main-"]');
    const mainVariant = () => variants.find((v) => String(v.id) === String(new FormData(mainForm()).get('id')));
    const panelLabel = (q) => q === 1 ? 'פלטה' : 'פלטות';
    const glueId = Number(root.dataset.glueVariantId || 0);
    const glueAvailable = root.dataset.glueAvailable === 'true' && glueId > 0;
    const scrollBehavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    let calculated = 0, added = 0, pending = false, gluePending = false, origin = '', activeOrigin = '', submitted = 0, timer, cartSerial = 0;
    let cachedQuantities = null, beforeQuantity = null, submittedVariant = '';
    let previousFocus, savedOverflow = '', flowChange = false, blockedUncertain = false, currentWall = null;
    function showError(message) { error.textContent = message; error.hidden = false; }
    function refreshTotal() {
      if (!mainForm()) return;
      const v = mainVariant();
      $('[data-panel-total]').textContent = v ? money(v.price * calculated) : '';
      apply.disabled = pending || blockedUncertain || !v?.available || !calculated;
      if (!v?.available) apply.textContent = 'המוצר אינו זמין להוספה לסל';
      else if (!pending) apply.textContent = `הוספת ${calculated} ${panelLabel(calculated)} לסל`;
    }
    async function refreshContext(cart) {
      const serial = ++cartSerial;
      try {
        if (!cart?.items) {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          cart = await response.json();
        }
        if (serial !== cartSerial || !root.isConnected) return;
        cachedQuantities = Object.fromEntries([...new Set(cart.items.map(i => String(i.variant_id)))].map(id => [id, cart.items.filter(i => String(i.variant_id) === id).reduce((n, i) => n + i.quantity, 0)]));
        const panels = cart.items.filter((i) => String(i.product_id) === root.dataset.productId).reduce((n, i) => n + i.quantity, 0);
        const glues = cart.items.filter((i) => Number(i.variant_id) === glueId).reduce((n, i) => n + i.quantity, 0);
        const context = document.querySelector('[data-dsv2-cart-context]');
        if (context) { context.hidden = panels === 0; context.textContent = `בסל: ${panels} ${panelLabel(panels)}${glues ? ` · ${glues} יח׳ דבק` : ''}`; }
        document.documentElement.dataset.dsv2PanelsInCart = String(panels);
      } catch (_) { const context = document.querySelector('[data-dsv2-cart-context]'); if (context) context.hidden = true; }
    }
    function finishGlue() {
      if (gluePending) return;
      modal.close(); modal.hidden = true;
      document.documentElement.style.overflow = savedOverflow;
      delete document.documentElement.dataset.dsv2GlueOpen;
      $('[data-applied-quantity]').textContent = added;
      $('[data-applied-label]').textContent = panelLabel(added);
      $('[data-applied-verb]').textContent = added === 1 ? 'נוספה' : 'נוספו';
      after.hidden = false;
      if (activeOrigin === 'calculator' && currentWall) {
        root.dispatchEvent(new CustomEvent('dsv3:wall-added', { detail: { panels: added, submitted, ...currentWall } }));
        refreshContext(); return;
      }
      const accessories = document.querySelector('[data-dsv2-accessories]');
      const target = accessories || after;
      target.focus({ preventScroll: true }); target.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
      refreshContext();
    }
    function updateGlueTotal() {
      const qty = Number(glueInput.value);
      const controls = glueInput.closest('quantity-selector')?.querySelectorAll('button');
      if (controls) { controls[0].disabled = glueInput.disabled || gluePending || qty <= 1; controls[1].disabled = glueInput.disabled || gluePending; }
      $('[data-glue-total]').textContent = money(Number(root.dataset.gluePrice) * (Number.isFinite(qty) ? qty : 0));
      glueButton.disabled = !glueAvailable || gluePending || !Number.isSafeInteger(qty) || qty < 1;
      if (!gluePending) glueButton.textContent = `הוספת ${qty || 0} יח׳ דבק לסל`;
    }
    function openGlue() {
      glueInput.value = Math.ceil(added * 1.5);
      $('[data-glue-panel-qty]').textContent = added;
      $('[data-glue-panel-success]').textContent = added;
      $('[data-glue-panel-label]').textContent = panelLabel(added);
      $('[data-glue-recommendation-label]').textContent = panelLabel(added);
      $('[data-glue-panel-verb]').textContent = added === 1 ? 'נוספה' : 'נוספו';
      $('[data-glue-partial]').hidden = added >= submitted;
      $('[data-glue-partial]').textContent = `התבקשו ${submitted} פלטות, אך נוספו רק ${added} עקב זמינות. המלצת הדבק מתייחסת לכמות שנוספה.`;
      $('[data-glue-qty]').textContent = glueInput.value;
      $('[data-glue-unavailable]').hidden = glueAvailable;
      glueInput.disabled = !glueAvailable;
      glueError.hidden = true; gluePending = false; updateGlueTotal();
      previousFocus = document.activeElement;
      savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.dataset.dsv2GlueOpen = 'true';
      modal.hidden = false; modal.showModal();
      (glueAvailable ? glueButton : modal.querySelector('[data-skip-glue]')).focus();
    }
    function unlock() {
      clearTimeout(timer); pending = false;
      width.readOnly = false; height.readOnly = false;
      form.querySelector('button').disabled = false;
      apply.removeAttribute('aria-busy');
    }
    on(form, 'submit', (event) => {
      event.preventDefault(); if (pending || blockedUncertain) return;
      error.hidden = true; warning.hidden = true; result.hidden = true; after.hidden = true;
      const w = Number(width.value), h = Number(height.value);
      calculated = 0;
      if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) return showError('יש להזין רוחב וגובה תקינים בסנטימטרים.');
      if (h > Number(root.dataset.unitHeight)) {
        const link = $('[data-height-consult]');
        if (link) {
          link.dataset.baseUrl ||= link.href;
          const url = new URL(link.dataset.baseUrl);
          const strings = JSON.parse($('[data-flow-strings]').textContent);
          const dimensions = strings.dimensions.replace('{width}', w).replace('{height}', h);
          url.searchParams.set('text', url.searchParams.get('text').replace('\n\nWALLPLANNER', `\n\n${dimensions}\n\nWALLPLANNER`));
          link.href = url.href;
        }
        warning.hidden = false; return;
      }
      calculated = Math.ceil(w / Number(root.dataset.coverageWidth));
      $('[data-result-quantity]').textContent = calculated;
      $('[data-result-label]').textContent = panelLabel(calculated);
      $('[data-result-wall-width]').textContent = w;
      $('[data-result-coverage]').textContent = Number((calculated * Number(root.dataset.coverageWidth)).toFixed(1));
      $('[data-result-surplus]').textContent = Number((calculated * Number(root.dataset.coverageWidth) - w).toFixed(1));
      result.hidden = false; refreshTotal();
    });
    [width, height].forEach((input) => on(input, 'input', () => { if (!pending) { calculated = 0; result.hidden = true; warning.hidden = true; error.hidden = true; } }));
    on(apply, 'click', () => {
      if (!calculated || pending || blockedUncertain) return;
      const productForm = mainForm();
      if (!productForm) return showError('לא מצאנו את טופס הרכישה. רעננו את העמוד ונסו שוב.');
      const button = Array.from(productForm.elements).find((el) => el.type === 'submit' && !el.disabled && el.getAttribute('aria-busy') !== 'true');
      if (!button) return showError('לא ניתן כרגע להוסיף את הפלטות לסל. בדקו את הזמינות באזור הרכישה.');
      let quantity = Array.from(productForm.elements).find((el) => el.name === 'quantity' && !el.disabled);
      if (!quantity) { quantity = document.createElement('input'); quantity.type = 'hidden'; quantity.name = 'quantity'; productForm.append(quantity); }
      quantity.value = calculated;
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
      currentWall = { width: Number(width.value), height: Number(height.value) };
      origin = 'calculator'; productForm.requestSubmit(button); origin = '';
    });
    on(document, 'submit', (event) => {
      if (event.target !== mainForm()) return;
      if (pending || blockedUncertain) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (!event.target.checkValidity() || event.submitter?.getAttribute('aria-busy') === 'true') return;
      submitted = Number(new FormData(event.target).get('quantity') || 1);
      if (!Number.isSafeInteger(submitted) || submitted < 1) return;
      submittedVariant = String(new FormData(event.target).get('id'));
      beforeQuantity = cachedQuantities ? (cachedQuantities[submittedVariant] || 0) : null;
      pending = true; activeOrigin = origin || 'hero';
      width.readOnly = true; height.readOnly = true; form.querySelector('button').disabled = true;
      apply.disabled = true; apply.setAttribute('aria-busy', 'true'); apply.textContent = 'מוסיף פלטות לסל...'; error.hidden = true;
      timer = setTimeout(() => { blockedUncertain = true; showError('עדיין לא התקבל אישור להוספה. בדקו את הסל לפני ניסיון נוסף או רענון העמוד.'); }, 30000);
    }, { capture: true });
    function confirmAddition(quantity, cart) {
      added = quantity; blockedUncertain = false; unlock();
      if (activeOrigin === 'calculator') { apply.disabled = true; apply.textContent = `${added} ${panelLabel(added)} ${added === 1 ? 'נוספה' : 'נוספו'} לסל`; }
      else refreshTotal();
      refreshContext(cart);
      flowChange = true;
      const legacy = document.getElementById('boa-upsale-popup');
      if (legacy) legacy.id = 'dsv2-paused-upsale-popup';
      queueMicrotask(() => { flowChange = false; if (legacy) legacy.id = 'boa-upsale-popup'; });
      openGlue();
    }
    on(document, 'variant:add', (event) => {
      if (event.target !== mainForm()) return;
      confirmAddition(submitted, event.detail?.cart);
    });
    on(document, 'cart:change', (event) => {
      if (flowChange && event.detail?.baseEvent === 'variant:add') event.detail.baseEvent = 'dsv2:panels-added';
      refreshContext(event.detail?.cart);
    }, { capture: true });
    on(document, 'cart:error', async (event) => {
      if (event.target !== mainForm()) return;
      clearTimeout(timer);
      const message = event.detail?.error || 'לא הצלחנו להוסיף את הפלטות לסל.';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error();
        const cart = await response.json();
        if (beforeQuantity === null) throw new Error();
        const current = cart.items.filter(i => String(i.variant_id) === submittedVariant).reduce((n, i) => n + i.quantity, 0);
        const delta = current - beforeQuantity;
        if (delta > 0 && delta <= submitted) {
          showError(message);
          confirmAddition(delta, cart);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } else if (delta === 0) {
          blockedUncertain = false; unlock(); refreshTotal(); showError(message); refreshContext(cart);
        } else throw new Error();
      } catch (_) {
        blockedUncertain = true; unlock(); refreshTotal(); showError(`${message} בדקו את הכמות בסל לפני ניסיון נוסף.`);
      }
    });
    on(document, 'variant:change', () => { if (!pending) refreshTotal(); });
    on(document, 'cart:refresh', () => refreshContext());
    on(window, 'pageshow', () => refreshContext());
    on(glueInput, 'input', updateGlueTotal);
    on(glueInput, 'change', updateGlueTotal);
    on(glueButton, 'click', async () => {
      const qty = Number(glueInput.value);
      if (!glueAvailable || gluePending || !Number.isSafeInteger(qty) || qty < 1) return;
      gluePending = true; glueInput.disabled = true; updateGlueTotal(); glueButton.disabled = true; glueButton.setAttribute('aria-busy', 'true'); glueButton.textContent = 'מוסיף דבק לסל...'; glueError.hidden = true;
      let confirmedFailure = false;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: glueId, quantity: qty }] }) });
        const payload = await response.json();
        if (!response.ok) { confirmedFailure = true; throw new Error(payload.description || 'לא הצלחנו להוסיף את הדבק לסל.'); }
        gluePending = false; glueButton.removeAttribute('aria-busy');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        finishGlue();
      } catch (err) {
        gluePending = false; glueButton.removeAttribute('aria-busy'); glueError.hidden = false;
        glueError.textContent = confirmedFailure ? err.message : 'לא התקבל אישור מהסל. בדקו את הסל לפני ניסיון נוסף.';
        if (confirmedFailure) { glueInput.disabled = false; updateGlueTotal(); }
      }
    });
    modal.querySelectorAll('[data-skip-glue]').forEach((button) => on(button, 'click', finishGlue));
    on(modal, 'cancel', (event) => { event.preventDefault(); finishGlue(); });
    on(document, 'shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      if (modal.open) { modal.close(); document.documentElement.style.overflow = savedOverflow; delete document.documentElement.dataset.dsv2GlueOpen; previousFocus?.focus(); }
      clearTimeout(timer); lifecycle.abort();
    });
    refreshContext();
  });
}
initDsv2WallCalculators();
document.addEventListener('shopify:section:load', (event) => initDsv2WallCalculators(event.target));


  } catch(e) { console.error(e); }
})();
})();
